import React, {useCallback, useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';

export default ({item, calculatePositionOfStickyHeaders, config, index}) => {
  let roles = useSelector((state) => state.roles.roles);
  const stuffRoles = useMemo(() => ['admin', 'editor', 'manager', 'seller']);
  roles = roles
    .filter((role) => stuffRoles.some((r) => r === role.title))
    .reverse();

  const isUserRole = useCallback(
    (role) => (item.roles.some((r) => r === role._id) ? 'user-has-role' : ''),
    [item.roles]
  );
  useEffect(() => {}, [roles]);
  return (
    <td
      className={`text-center p-0 ${index === 0 ? 'first-cell' : ''}`}
      style={{
        ...calculatePositionOfStickyHeaders(config),
        verticalAlign: 'middle',
      }}
    >
      <div className="overview-cell d-flex align-items-center justify-content-center">
        {roles.map((role) => (
          <div
            key={role.title}
            className={`d-flex justify-content-center align-items-center py-1 ${isUserRole(
              role
            )}`}
          >
            <span>{role.title.capitalize()}</span>
          </div>
        ))}
      </div>
    </td>
  );
};
